















































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import CancelJobWorkerOfferRequest from '@/models/JobWorkerOffers/CancelJobWorkerOfferRequest';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import ListUtils from '@/lib/listUtils';
import UpdateJobWorkerOfferContactConfirmationRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferContactConfirmationRequest';

@Component({
    name: 'JobWorkerOfferStatusSetContactDeclined'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorkerOffer: JobWorkerOfferDto;

  request: UpdateJobWorkerOfferContactConfirmationRequest = new UpdateJobWorkerOfferContactConfirmationRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateJobWorkerOfferContactConfirmationRequest();
    } 
    this.$emit("closeMenu");
  }

  get declinedReasons() {
    return ListUtils.jobWorkerOfferContactDeclinedReasons();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
    this.request.updatedAt = this.jobWorkerOffer.updatedAt;
    await JobDetailsModule.updateJobWorkerOfferContactConfirmation(this.request);
    this.dialog = false;
  }
}
